<div id="acc-root" class="acc-overlay" (click)="closeModal()">
  <section
    class="acc-card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="acc-title"
    (click)="$event.stopPropagation()"
  >
    <!-- Résultat de création -->
    <div *ngIf="createdUser" class="acc-success-view">
      <div class="success-icon">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 6L9 17l-5-5" />
        </svg>
      </div>
      <h2 class="success-title">{{ 'components.addUserModal.success.title' | translate }}</h2>
      <p class="success-message">{{ createdUser.message }}</p>

      <div class="success-detail">
        <span class="success-detail-label">{{ 'components.addUserModal.success.emailLabel' | translate }}</span>
        <span class="success-detail-value">{{ createdUser.email }}</span>
      </div>

      <p class="success-note">{{ 'components.addUserModal.success.note' | translate }}</p>

      <div class="form-actions form-actions--center">
        <button type="button" class="btn btn--primary" (click)="closeModal()">{{ 'components.addUserModal.success.close' | translate }}</button>
      </div>
    </div>

    <!-- Formulaire de création -->
    <ng-container *ngIf="!createdUser">
      <div class="acc-header">
        <div>
          <h2 id="acc-title">{{ 'components.addUserModal.header.title' | translate }}</h2>
          <p class="acc-subtitle">{{ 'components.addUserModal.header.subtitle' | translate }}</p>
        </div>
        <button type="button" class="acc-close" (click)="closeModal()" [attr.aria-label]="'components.addUserModal.header.closeAriaLabel' | translate">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      <form class="acc-body user-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="field-row">
          <div class="field-group">
            <label class="field-label" for="acc-first">{{ 'components.addUserModal.fields.firstName' | translate }}</label>
            <input
              id="acc-first"
              type="text"
              formControlName="firstName"
              class="field-input"
              [class.error]="form.get('firstName')?.invalid && form.get('firstName')?.touched"
            />
            <span
              class="field-error"
              *ngIf="form.get('firstName')?.invalid && form.get('firstName')?.touched"
            >
              {{ 'components.addUserModal.fields.firstNameError' | translate }}
            </span>
          </div>

          <div class="field-group">
            <label class="field-label" for="acc-last">{{ 'components.addUserModal.fields.lastName' | translate }}</label>
            <input
              id="acc-last"
              type="text"
              formControlName="lastName"
              class="field-input"
              [class.error]="form.get('lastName')?.invalid && form.get('lastName')?.touched"
            />
            <span
              class="field-error"
              *ngIf="form.get('lastName')?.invalid && form.get('lastName')?.touched"
            >
              {{ 'components.addUserModal.fields.lastNameError' | translate }}
            </span>
          </div>
        </div>

        <div class="field-group">
          <label class="field-label" for="acc-mail">{{ 'components.addUserModal.fields.email' | translate }}</label>
          <input
            id="acc-mail"
            type="email"
            formControlName="email"
            class="field-input"
            [class.error]="form.get('email')?.invalid && form.get('email')?.touched"
          />
          <span class="field-error" *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
            <span *ngIf="form.get('email')?.hasError('required')">{{ 'components.addUserModal.fields.emailRequiredError' | translate }}</span>
            <span *ngIf="form.get('email')?.hasError('email')">{{ 'components.addUserModal.fields.emailFormatError' | translate }}</span>
          </span>
        </div>

        <div class="perm-section">
          <div class="perm-title">{{ 'components.addUserModal.permissions.title' | translate }}</div>
          <div class="perm-grid">
            <button
              type="button"
              *ngFor="let perm of visiblePermissions"
              class="perm-chip"
              [class.active]="hasPermission(perm.key)"
              (click)="togglePermission(perm.key)"
            >
              {{ perm.label }}
            </button>
          </div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn--ghost" [disabled]="loading" (click)="closeModal()">
            {{ 'components.addUserModal.actions.cancel' | translate }}
          </button>
          <button type="submit" class="btn btn--primary" [disabled]="loading || form.invalid">
            {{ loading ? ('components.addUserModal.actions.creating' | translate) : ('components.addUserModal.actions.create' | translate) }}
          </button>
        </div>
      </form>
    </ng-container>
  </section>
</div>
